import { render, staticRenderFns } from "./BerkleyPolicyDetailActionsIssuePolicy.vue?vue&type=template&id=9f29c494"
import script from "./BerkleyPolicyDetailActionsIssuePolicy.vue?vue&type=script&lang=js"
export * from "./BerkleyPolicyDetailActionsIssuePolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports